import { render, staticRenderFns } from "./SalesPromo.vue?vue&type=template&id=1926f7ef&scoped=true&"
import script from "./SalesPromo.vue?vue&type=script&lang=js&"
export * from "./SalesPromo.vue?vue&type=script&lang=js&"
import style0 from "./SalesPromo.vue?vue&type=style&index=0&id=1926f7ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1926f7ef",
  null
  
)

export default component.exports